import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import {
  getCardIcon,
  getCardIconType,
  getCardTitle,
} from "../mockSubscriptionData";
import CalendarLoader from "../../../common-components/CalendarLoader";

const LiveSubsStats = ({ statsData, setStatsData }) => {
  const { liveSubsStats, liveSubsStatsError, liveSubsStatsLoading } =
    useSelector((state) => state.live);

  useEffect(() => {
    if (!liveSubsStatsLoading && !liveSubsStatsError && liveSubsStats?.status) {
      setStatsData(liveSubsStats?.data);
    } else {
      setStatsData({
        total: 0,
        regular_subscriptions: 0,
        personal_training: 0,
      });
    }
  }, [liveSubsStatsLoading, liveSubsStatsError, liveSubsStats]);

  return (
    <div className="live-subscriptions mr-kpi-grid grid-3 mt30">
      {liveSubsStatsLoading ? (
        <CalendarLoader daysCount={3} shiftsPerDay={2} />
      ) : (
        statsData &&
        Object.entries(statsData)?.map(([key, data]) => {
          return (
            <div className="mr-kpi-card" key={key}>
              <div className="mr-kpi-head">
                <div>
                  <p className="mr-kpi-title">{getCardTitle(key)}</p>
                  <div className="mr-kpi-value-row">
                    <div className="mr-kpi-value">{data || 0}</div>
                  </div>
                </div>
                <span
                  className="mr-kpi-card-icon-container"
                  style={{
                    backgroundColor:
                      getCardIconType(key) === "blue"
                        ? "#dbeafe"
                        : getCardIconType(key) === "green"
                        ? "#d1fae5"
                        : getCardIconType(key) === "orange"
                        ? "#fed7aa"
                        : "#f3f4f6",
                    color:
                      getCardIconType(key) === "blue"
                        ? "#1e40af"
                        : getCardIconType(key) === "green"
                        ? "#065f46"
                        : getCardIconType(key) === "orange"
                        ? "#c2410c"
                        : "#374151",
                  
                  }}
                >
                  {getCardIcon(key)}
                </span>
              </div>
            </div>
          );
        })
      )}
    </div>
  );
};

export default LiveSubsStats;